/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const KLEFKI_LOGO = require("./res/images/klefki.png");

export const DUMMY_IMAGE = require("./res/images/300-300.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.png");
export const VLINDER_IMAGE = require("./res/images/vlinder-logo.png");
export const NO_ASSET = require("./res/images/no-data.svg");
export const NO_IMAGE = require("./res/images/no-image.png");

export const GOLD_ICON = require("./res/images/gold.webp");
export const PLATINUM_ICON = require("./res/images/platinum-1.webp");
export const DIAMOND_ICON = require("./res/images/diamond.webp");
export const ETHER = require("./res/images/ether.webp");
export const MATIC = require("./res/images/matic.webp");

export const TRAG_LIGHT_LOGO = require("./res/images/trag-2.png");
export const PRODUCT_JOURNEY = require("./res/images/product_journey.png");
export const PROTECT_B_AND_C = require("./res/images/Protect_brand_and_customer.png");
export const TRAG_ILLUSTRATION = require("./res/images/trag-illustration.png");
export const TRAG_LOGO = require("./res/images/trag.png");
export const TRANSPARENCY = require("./res/images/Transparency.png");
export const BANNER_IMAGE = require("./res/images/bg.png");
export const AUTHENTICITY = require("./res/images/Authenticity.png");
export const EFFICIENCY = require("./res/images/Efficiency.png");
export const CUSTOMER_ENGAGEMENT = require("./res/images/Customer_Engagement.png");
export const ELEVATE_CE = require("./res/images/Elevate_customer_experience.png");
export const LOCATION_NOT_FOUND = require("./res/images/locationNotFound.png");
export const PLAY_BTN = require(`./res/images/play_btn.png`);

export const IMAGES = [
    VLINDER_LOGO,
    KLEFKI_LOGO,
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,
    VLINDER_IMAGE,
    NO_ASSET,
    NO_IMAGE,
    GOLD_ICON,
    PLATINUM_ICON,
    DIAMOND_ICON,
    ETHER,
    MATIC,
    TRAG_LIGHT_LOGO,
    PRODUCT_JOURNEY,
    PROTECT_B_AND_C,
    TRAG_ILLUSTRATION,
    TRAG_LOGO,
    TRANSPARENCY,
    BANNER_IMAGE,
    AUTHENTICITY,
    EFFICIENCY,
    CUSTOMER_ENGAGEMENT,
    ELEVATE_CE,
    LOCATION_NOT_FOUND,
    PLAY_BTN,
];
